import {
  AnyChatMessageBlock,
  ChatMessageBlock,
  ChatMessageBlockType,
  ChatMessageTextBlock,
} from './chat-types';
import { ImageRegistration, MunchedImage } from './image-muncher-types';

export interface SalesfloorParticipant {
  id: string;
  displayName: string;
  avatarUrl: string | null;
  lastActivity: string | null;
  status: string;
}

export interface SalesfloorTypingMessageBlock
  extends ChatMessageBlock<ChatMessageBlockType.TYPING> {
  isTyping: boolean;
}

export type AnySalesfoorChatMessageBlock =
  | AnyChatMessageBlock
  | SalesfloorTypingMessageBlock;

export interface SalesfloorChatMessageContent {
  blocks: AnySalesfoorChatMessageBlock[];
}

export interface SalesfloorChatBaseMessage {
  id: string;
  conversationId: string;
  timestamp: number;
  sender: SalesfloorParticipant;
}

export enum SalesfloorChatMessageType {
  CONTENT = 'content',
  TYPING = 'typing',
}

export interface SalesfloorChatContentMessage extends SalesfloorChatBaseMessage {
  type: SalesfloorChatMessageType.CONTENT;

  content: SalesfloorChatMessageContent;
  mentionedUserIds?: number[];
  pending?: boolean;
  imageIds?: string[];
  images?: MunchedImage[];
}

export interface SalesfloorChatTypingNotificationMessage
  extends SalesfloorChatBaseMessage {
  type: SalesfloorChatMessageType.TYPING;
  isTyping: boolean;
}

export type SalesfloorChatMessage =
  | SalesfloorChatContentMessage
  | SalesfloorChatTypingNotificationMessage;

export type SalesfloorChatMessageArgs = {
  registeredImg?: ImageRegistration;
  file?: Blob;
};

export function getSalesfloorMessageText(message: SalesfloorChatContentMessage): string {
  const texts = message.content.blocks
    .filter(b => b.type == ChatMessageBlockType.TEXT)
    .map(b => (b as ChatMessageTextBlock).text);
  return texts.join(' ');
}

export interface OwnUser {
  id: number;
  type: string;
}

export interface SalesfloorChannelUpdate {
  ownUser: OwnUser;
  message: SalesfloorChatMessage;
}
